module.exports = __webpack_public_path__ + "static/media/ecomex-logo.bebdc3b3.svg";